function SecondDiagnosisRefusalWrapperVO(rejectionReason) {

	this.rejectionReason = rejectionReason;

	var _typeContext = {
	};

	this._getType = function (property) {
		if (_typeContext.hasOwnProperty(property)) {
			return _typeContext[property];
		}
		else {
			return undefined;
		}
	};

	var _mappingContext = {};

	this._getMapping = function (property) {
		if (_mappingContext[property]) {
			return _mappingContext[property];
		}
		else {
			return undefined;
		}
	};
}
